import {
  HookLookupsRefresh,
  HookLookupsRefresh_Type,
} from "../../../global/hooks"
import type { SYSAction, SYSFeature } from "../../../index"
import { SYSFormState } from "../formapi"
import { KeyValueListFromServerFn } from "./helpers"
import type { ListState } from "./listcontrol"

export const _FillListControl: SYSAction<{
  list: ListState
  columnKey: string
  filterValue: string
  row: {}
  feature: SYSFeature
  formState: SYSFormState
}> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let fn = actions.app.features[value.feature]
  if (fn?.hooks?.[HookLookupsRefresh]) {
    let lookups = fn.hooks[HookLookupsRefresh](<HookLookupsRefresh_Type>{
      formState: value.formState,
      tableDefId: value.formState.tableDefId,
    })
    await KeyValueListFromServerFn(
      state,
      value.list,
      value.columnKey,
      lookups,
      value.filterValue,
      value.row,
      value.feature,
      value.formState?.subFeature,
      value.formState?.formType,
      value.formState?.formId,

      undefined,
      undefined
    )
  } else {
    throw Error("SYS Error: RefreshLookups Hook is mandatory for any list")
  }
}
